import { render, staticRenderFns } from "./ItemAttributeContent.vue?vue&type=template&id=c4f91f0a&scoped=true&"
import script from "./ItemAttributeContent.vue?vue&type=script&lang=js&"
export * from "./ItemAttributeContent.vue?vue&type=script&lang=js&"
import style0 from "./ItemAttributeContent.vue?vue&type=style&index=0&id=c4f91f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f91f0a",
  null
  
)

export default component.exports